<template>
  <div class="page">
    <!-- 顶部导航栏 -->
    <el-row class="nav" type="flex" justify="space-between">
      <el-col style="color:#fff;fontSize:23px;lineHeight:80px;marginLeft:53px;"
        >社区治理</el-col
      >
      <el-col style="height:80px;" class="icon-box">
        <img
          src="../assets/images/governmentAffairs/return-ico.png"
          alt=""
          height="50%"
          style="marginRight:53px;"
          @click="returntopone"
        />
        <!-- <span class="nav-xian"></span> -->
        <img
          src="../assets/images/governmentAffairs/xian.png"
          alt=""
          height="50%"
          style="margin: 14px 15px"
        />
        <img
          src="../assets/images/governmentAffairs/return-index.png"
          alt=""
          height="50%"
          @click="returnIndex"
        />
      </el-col>
    </el-row>
    <div class="body-card">
      <!-- 中间方块图 -->
      <el-row class="btn-box" type="flex" justify="space-between">
        <el-col class="img1 body-img-c">
          <img src="../assets/images/governmentAffairs/t1.png" alt="" />
        </el-col>
        <el-col class="img2 body-img-c">
          <img src="../assets/images/governmentAffairs/t2.png" alt="" />
        </el-col>
        <el-col class="img3 body-img-c">
          <img src="../assets/images/governmentAffairs/t3.png" alt="" />
        </el-col>
      </el-row>
      <el-row class="btn-box" type="flex" justify="space-between">
        <el-col class="img4 body-img-c">
          <img src="../assets/images/governmentAffairs/t4.png" alt="" />
        </el-col>
        <el-col class="img5 body-img-c">
          <img src="../assets/images/governmentAffairs/t5.png" alt="" />
        </el-col>
        <el-col class="img6 body-img-c">
          <img src="../assets/images/governmentAffairs/t6.png" alt="" />
        </el-col>
      </el-row>
      <el-row class="btn-box" type="flex" justify="space-between">
        <el-col class="img7 body-img-c">
          <img src="../assets/images/governmentAffairs/t7.png" alt="" />
        </el-col>
        <el-col class="img8 body-img-c">
          <img
            src="../assets/images/governmentAffairs/t8.png"
            alt=""
            @click.prevent="goChildPage('griddingindex')"
          />
        </el-col>
        <el-col class="img9 body-img-c">
          <img src="../assets/images/governmentAffairs/t9.png" alt="" />
        </el-col>
      </el-row>
      <!-- 底部按钮 -->
      <el-row class="btn-box btn-footer" type="flex" justify="center">
        <el-col :span="2"
          ><img src="../assets/images/governmentAffairs/b1.png" alt=""
        /></el-col>

        <el-col :span="2"
          ><img src="../assets/images/governmentAffairs/b2.png" alt=""
        /></el-col>

        <el-col :span="2"
          ><img src="../assets/images/governmentAffairs/b3.png" alt=""
        /></el-col>

        <el-col :span="2"
          ><img src="../assets/images/governmentAffairs/b4.png" alt=""
        /></el-col>

        <el-col :span="2"
          ><img src="../assets/images/governmentAffairs/b5.png" alt=""
        /></el-col>

        <el-col :span="2"
          ><img src="../assets/images/governmentAffairs/b6.png" alt=""
        /></el-col>

        <el-col :span="2"
          ><img src="../assets/images/governmentAffairs/b7.png" alt=""
        /></el-col>

        <el-col :span="2"
          ><img src="../assets/images/governmentAffairs/b8.png" alt=""
        /></el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  methods: {
    gopsge2() {
      this.$router.push({ name: "governmentAffairs" });
    },
    returntopone() {
      this.$router.go(-1);
    },
    returnIndex() {
      this.$router.push({ name: "login" });
    },
    // 中间9个图片的跳转链接
    goChildPage(e) {
      console.log(e);

      this.$router.push({ name: e });
    }
  }
};
</script>

<style lang="less" scoped>
// 整个页面盒子
.page {
  background-image: url("../assets/images/lg-bg.jpg");
  background-position: center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;
  position: relative;
}
// 顶部导航栏
.nav {
  height: 80px;
  background-image: url("../assets/images/governmentAffairs/nav-bg.png");
  background-size: 100% 110%;
  background-repeat: no-repeat;
  .icon-box img {
    float: right;
    // background-color: #fff;
    // width: 1px;
    height: 60%;
    // margin: 15% 15px;
    margin-top: 14px;
    cursor: pointer;
  }
}
// 中间方块图
.body-card {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  margin-top: 30px;
  width: 100%;
  transition: all 0.4s ease;
}

.btn-box {
  min-height: 60px;
  padding: 0 53px;
  position: relative;
  .body-img-c {
    transition: all 0.4s ease;
  }
  .body-img-c:hover {
    // transform: scale(1.2, 1.2);
    transform: translateY(-5px);
    box-shadow: 0px 0px 5px 5px #ac5344;
  }
  .el-col {
    height: 17vh;
    margin: 10px;
    box-sizing: border-box;
    background-position: center center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    cursor: pointer;
  }
  .img1 {
    background-image: url("../assets/images/governmentAffairs/btn1.png");
  }
  .img2 {
    background-image: url("../assets/images/governmentAffairs/btn2.png");
  }
  .img3 {
    background-image: url("../assets/images/governmentAffairs/btn3.png");
  }
  .img4 {
    background-image: url("../assets/images/governmentAffairs/btn4.png");
  }
  .img5 {
    background-image: url("../assets/images/governmentAffairs/btn5.png");
  }
  .img6 {
    background-image: url("../assets/images/governmentAffairs/btn6.png");
  }
  .img7 {
    background-image: url("../assets/images/governmentAffairs/btn7.png");
  }
  .img8 {
    background-image: url("../assets/images/governmentAffairs/btn8.png");
  }
  .img9 {
    background-image: url("../assets/images/governmentAffairs/btn9.png");
  }
}
.btn-box img {
  height: 50%;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  // cursor: pointer;
}
// 底部按钮
.btn-footer {
  margin-top: 4vh;
  background-image: url("../assets/images/governmentAffairs/footer-bg.png");
  background-position: center bottom;
  background-size: 100% 50%;
  background-repeat: no-repeat;
  position: relative;
  .el-col {
    width: 100%;
    height: 100%;
    position: relative;
    padding: 10px;
    transition: all 0.4s ease;
    // transform: scale(0.9, 0.9);
  }
  .el-col:nth-child(1) {
    transform: scale(1.2, 1.2);
  }
  img {
    // width: 100%;
    height: 100%;

    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .el-col:hover {
    transform: scale(1.2, 1.2);
    // transform: translateY(-3px);
  }
  .el-col {
    height: 17vh;
    margin: 10px;
    box-sizing: border-box;
  }
}
</style>